import React from "react";
import {
    Box,
    Skeleton,
    Text,
} from "@chakra-ui/react";
import Chart from "react-apexcharts";

const AgentPerformanceChart = ({
    data = [],
    isLoading,
}) => {
    const agents = data.map(
        (agent) =>
            agent.agent_name ||
            agent.agent_number ||
            "Unknown Agent"
    );

    const scores = data.map(
        (agent) => agent.performance_score ?? 0
    );

    const options = {
        chart: {
            type: "bar",
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 4,
                barHeight: "55%",
            },
        },
        dataLabels: {
            enabled: true,
        },
        xaxis: {
            categories: agents,
            min: 0,
            max: 100,
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: "11px",
                },
            },
        },
        grid: {
            strokeDashArray: 4,
        },
    };

    return (
        <Box
            bg="white"
            borderRadius="15px"
            p="24px"
            height="400px"
            width="100%"
            boxShadow="sm"
        >
            <Text
                color="#071D54"
                fontSize="lg"
                fontWeight="700"
                mb={4}
            >
                Agent Performance Score
            </Text>

            {isLoading ? (
                <Skeleton
                    height="300px"
                    borderRadius="12px"
                />
            ) : data.length === 0 ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="300px"
                >
                    <Text
                        color="gray.500"
                        fontSize="sm"
                    >
                        No agent performance data available.
                    </Text>
                </Box>
            ) : (
                <Chart
                    options={options}
                    series={[
                        {
                            name: "Performance Score",
                            data: scores,
                        },
                    ]}
                    type="bar"
                    height={300}
                />
            )}
        </Box>
    );
};

export default AgentPerformanceChart;